export interface UserData {
  firstName: string;
  lastName: string;
  email: string;
  PublicServiceNumber: string;
  BirthDate: string;
}

export const users: UserData[] = [
  {
    firstName: "XXXSNOWBALL",
    lastName: "XXXCHANCE",
    email: "ootseu@gmail.com",
    PublicServiceNumber: "0119090P",
    BirthDate: "1943-03-02",
  },
  {
    firstName: "XXXSANTASLITTLEHELPE",
    lastName: "XXXCLAWS",
    email: "o.otseu@gmail.com",
    PublicServiceNumber: "0119100P",
    BirthDate: "1921-10-02",
  },
  {
    firstName: "XXXJACKO",
    lastName: "XXXWACKO",
    email: "oo.tseu@gmail.com",
    PublicServiceNumber: "1373010T",
    BirthDate: "1945-06-24",
  },
  {
    firstName: "XXXPEDRO",
    lastName: "XXXODWYER",
    email: "oot.seu@gmail.com",
    PublicServiceNumber: "1050266G",
    BirthDate: "1941-08-27",
  },
  {
    firstName: "DP XXXMARK",
    lastName: "XXXSWEETS",
    email: "oots.eu@gmail.com",
    PublicServiceNumber: "1049534V",
    BirthDate: "1990-01-28",
  },
  {
    firstName: "DP XXXMARK",
    lastName: "XXXBAKER",
    email: "ootse.u@gmail.com",
    PublicServiceNumber: "1049193V",
    BirthDate: "1980-06-02",
  },
  {
    firstName: "XXXCHRISTOPHER",
    lastName: "XXXCOLUMBUS",
    email: "ootseu1@gmail.com",
    PublicServiceNumber: "1447606P",
    BirthDate: "2006-03-01",
  },
  {
    firstName: "DP XXXOWEN",
    lastName: "XXXKART",
    email: "o.otseu1@gmail.com",
    PublicServiceNumber: "1271742U",
    BirthDate: "2000-02-29",
  },
  {
    firstName: "XXXROSE",
    lastName: "XXXGARDEN",
    email: "oo.tseu1@gmail.com",
    PublicServiceNumber: "0121506JW",
    BirthDate: "1938-09-23",
  },
];
